export const canPublishProduct = () => () => {
    return function (nodes) {
        return [...nodes].filter(
            node => this.actions.canPublishProduct(node)
        )
    }
}

export const publishProduct = () => {
    return () => async function (nodes) {
        await this.execute(
            () => this.runParallelAction(
                () => this.actions.publishProduct(nodes),
                {action: '发布模型制品'},
            )
        )
    }
}
